<template>
  <header id="mainHeader" class="l-mainHeader">
    <div class="l-mainHeader__leftWrapper">
      <div class="l-mainHeader__serviceLogoWrapper">
        <router-link to="/master_admin">
          <img
            class="l-mainHeader__serviceLogo"
            src="@/assets/master_logo.svg"
            alt="b-master"
          />
        </router-link>
      </div>
      <div class="l-mainHeader__gMenuWrapper">
        <slot name="left" />
      </div>
    </div>
    <div class="l-mainHeader__rightWrapper">
      <slot name="right" />
    </div>
  </header>
</template>

<script>
export default {
  name: 'MasterAdminHeader'
}
</script>

<style scoped lang="sass">
.l-mainHeader
  position: fixed
  border-bottom: 1px solid #BEBEBE
  background: #fff
  height: 60px
  display: flex
  justify-content: space-between
  width: 100%
  z-index: 99
  &__leftWrapper
    height: 100%
    display: flex
  &__rightWrapper
    width: 150px
    height: 100%
    display: flex
    justify-content: center
    align-items: center
  &__gMenuWrapper
    min-width: 600px
    margin-left: 100px
    height: 60px
    display: flex
  &__serviceLogoWrapper
    height: 50px
    width: 150px
    padding-top: 10px
    padding-left: 20px
    padding-bottom: 15px
  &__serviceLogo
    display: block
    margin: 0 auto
    width: 100%
.p-accountIcon
  vertical-align: middle
  &__img
    display: block
    border: 2px solid #D3D3D3
    border-radius: 50%
    height: 40px
    width: 40px
    &:hover
      cursor: pointer
.accountMenu
  z-index: 999
</style>
